import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Global config
global.CONFIG = require('./page.config.js')

// Global styles
import 'ASSETS/scss/custom.scss'

// Libs
import _informativeDate from './libs/informativeDate'
import _sendRequest      from './libs/sendRequest'
import _redirect         from './libs/redirect'

// Global components
import {
  Alert, Loading, Header, Sidebar, DropDown, Select, FloatMenu, Modal,
  InputRecovery, Table, DropFile, Steps, MultiSelect, Checkbox, ContextMenu,
  BreadCrumb, ChatParticipant, InterPhoneInput, InputPassword
} from './components'

// 3rd-party UI
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

// Templates
import T_login from 'TEMPLATES/Tlogin'
import T_dashboard from 'TEMPLATES/Tdashboard'

// ECharts
import VueECharts from 'vue-echarts'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart, BarChart, PieChart } from 'echarts/charts'
import { GridComponent, TooltipComponent, LegendComponent, TitleComponent } from 'echarts/components'
use([CanvasRenderer, LineChart, BarChart, PieChart, GridComponent, TooltipComponent, LegendComponent, TitleComponent])

// ---------- create app FIRST ----------
const app = createApp(App)

// then register plugins/components
app.component('v-chart', VueECharts)
app.use(store)
app.use(router)
app.use(VueTelInput)

// Templates
app.component('login', T_login)
app.component('dashboard', T_dashboard)

// Components
app.component('fa-alert', Alert)
app.component('fa-loading', Loading)
app.component('fa-header', Header)
app.component('fa-sidebar', Sidebar)
app.component('fa-select', Select)
app.component('fa-dropdown', DropDown)
app.component('fa-modal', Modal)
app.component('fa-input-recovery', InputRecovery)
app.component('fa-table', Table)
app.component('fa-floatmenu', FloatMenu)
app.component('fa-dropfile', DropFile)
app.component('fa-steps', Steps)
app.component('fa-multy-select', MultiSelect)
app.component('fa-check', Checkbox)
app.component('fa-context-menu', ContextMenu)
app.component('fa-bread-crumb', BreadCrumb)
app.component('fa-chat-participant', ChatParticipant)
app.component('fa-inter-input', InterPhoneInput)
app.component('fa-input-password', InputPassword)
app.component('fa-date-picker', VueDatePicker)

// Provide libs
app.provide('$informativeDate', _informativeDate)
app.provide('$sendRequest', _sendRequest)
app.provide('$redirect', _redirect)

// Mount
app.mount('#app')
